<template>
  <div class="resizable-container">
    <div class="top-section" :style="showBottom ? {} : { flexBasis: '100%' }">
      <slot name="top"></slot>
    </div>
    <div
      v-if="showBottomSection"
      class="divider"
      :style="{ display: showBottom ? 'block' : 'none' }"
      @mousedown="startResizing"
      @mouseup="stopResizing"
    ></div>
    <div
      v-if="showBottomSection"
      class="bottom-section"
      :style="{ display: showBottom ? 'block' : 'none' }"
    >
      <slot name="bottom"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VasionResizableLayout',
  props: {
    showBottomSection: {
      type: Boolean,
      default: true,
    },
    initialBottomPercentage: {
      type: Number,
      default: 50,
      validator(value) {
        return value >= 0 && value <= 100
      },
    },
  },
  data() {
    return {
      isResizing: false,
      containerHeight: 0,
      minHeight: 50,
      showBottom: this.showBottomSection,
    }
  },
  watch: {
    showBottomSection: {
      immediate: true,
      handler(val) {
        this.showBottom = val
      },
    },
  },
  mounted() {
    this.setInitialSizes()
  },
  methods: {
    setInitialSizes() {
      const container = this.$el
      const topSection = container.querySelector('.top-section')
      const bottomSection = container.querySelector('.bottom-section')
      const containerHeight = container.getBoundingClientRect().height

      const bottomHeight =
        (containerHeight * this.initialBottomPercentage) / 100
      const topHeight = containerHeight - bottomHeight - 5

      topSection.style.flexBasis = `${topHeight}px`
      bottomSection.style.flexBasis = `${bottomHeight}px`
    },
    startResizing() {
      this.isResizing = true
      this.containerHeight = this.$el.getBoundingClientRect().height

      // Disable text selection
      document.body.style.userSelect = 'none'

      document.addEventListener('mousemove', this.resize)
      document.addEventListener('mouseup', this.stopResizing)
    },
    resize(event) {
      if (!this.isResizing) return

      const containerRect = this.$el.getBoundingClientRect()
      const offsetY = event.clientY - containerRect.top

      const maxHeight = this.containerHeight - this.minHeight

      if (offsetY > this.minHeight && offsetY < maxHeight) {
        const topSection = this.$el.querySelector('.top-section')
        const bottomSection = this.$el.querySelector('.bottom-section')
        const dividerHeight = 5

        topSection.style.flexBasis = `${offsetY}px`
        bottomSection.style.flexBasis = `${
          this.containerHeight - offsetY - dividerHeight
        }px`
      }
    },
    stopResizing() {
      this.isResizing = false

      // Re-enable text selection
      document.body.style.userSelect = ''

      document.removeEventListener('mousemove', this.resize)
      document.removeEventListener('mouseup', this.stopResizing)
    },
  },
}
</script>

<style scoped>
.resizable-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.top-section,
.bottom-section {
  overflow: auto;
}

.top-section,
.bottom-section {
  flex-basis: 50%;
}

.bottom-section {
  padding-left: 4px;
  padding-right: 4px;
  background-color: #ccc;
}

.divider {
  height: 5px;
  background-color: #ccc;
  cursor: row-resize;
}
</style>
